/**
 * The payment email's ACH link (`?ach=true`, also honey's copy link) takes a bank account only.
 * Any truthy `ach`, as PaymentForm.vue read it before Recurly.
 *
 * Lives in its own module (no Apollo/Recurly imports) so the middleware, which runs on every
 * route, can read the same flag the payment page reads.
 */
export const isBankOnlyQuery = (query?: Record<string, any>) => !!query?.ach;

export default isBankOnlyQuery;
